import React, { Suspense } from "react";

import { Menubar } from "primereact/menubar";

import styles from "./layout.module.css";
import { Button } from "primereact/button";
import { Link, Outlet, useLocation } from "react-router-dom";
import PathConstants from "routes/pathConstants";
import { ProgressSpinner } from "primereact/progressspinner";
import Header from "components/layout/Header";
import { itemRendererCitizen } from "components/layout/navItem.template";

const Layout = () => {
  const location = useLocation();

  const navItems = [
    {
      label: "Home",
      icon: "pi pi-home",
      url: PathConstants.HOME,
      template: (item, options) => itemRendererCitizen(item, options, location),
    },
    {
      label: "Search Property",
      icon: "pi pi-search",
      url: PathConstants.SEARCH_PROPERTY,
      template: (item, options) => itemRendererCitizen(item, options, location),
    },
    {
      label: "View Ledger",
      icon: "pi pi-book",
      url: PathConstants.LEDGER,
      template: (item, options) => itemRendererCitizen(item, options, location),
    },
    {
      label: "View Receipt",
      icon: "pi pi-receipt",
      url: PathConstants.PAYMENT_RECEIPT,
      template: (item, options) => itemRendererCitizen(item, options, location),
    },
    {
      label: "Objection Status",
      icon: "pi pi-exclamation-circle",
      url: PathConstants.OBJECTION_STATUS,
      template: (item, options) => itemRendererCitizen(item, options, location),
    },
  ];

  return (
    <>
      <Header />

      <Menubar
        model={navItems}
        end={
          <Link to="/auth/login">
            <Button icon="pi pi-users" label="Nigam Login" type="button" />
          </Link>
        }
      />
      <main className={styles.main}>
        <Suspense
          fallback={() => (
            <div className="flex align-items-center justify-content-center">
              <ProgressSpinner />
            </div>
          )}
        >
          <Outlet />
        </Suspense>
      </main>
    </>
  );
};

export default Layout;
